import React, { FC } from 'react';
import Fade from 'react-reveal/Fade';
import { TImageTextWrapFade } from '../../types/interactiveImage.types';

const WrapFade: FC<TImageTextWrapFade> = (props) => {
  const { duration, delay, children, isDesktop, isEE } = props;

  if (isDesktop && !isEE) {
    return (
      <Fade bottom duration={duration} delay={delay}>
        {children}
      </Fade>
    );
  }
  return <>{children}</>;
};

export default WrapFade;
